import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-redirect',
  standalone: true,
  template: '' // Kein UI notwendig, nur Umleitung
})
export class DsabRedirectComponent
{
  constructor(private route: ActivatedRoute, private router: Router)
  {
    // Alle Query-Parameter aus der aktuellen Route holen
    const queryParams = this.route.snapshot.queryParams;

    // Weiterleitung zur Ziel-URL mit allen Query-Parametern
    this.router.navigate(['/frontend/events/9/mandant/1758'], { queryParams });
  }
}
